import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Image } from '../models/image';
import { FwHttpService } from './fw-http.service';
import { KeywordService } from './keyword.service';


@Injectable()
export class ImageService {

  static prefix = 'images';

  constructor(private http: FwHttpService) { }

  public countAll() {
    return this.http.getSearch(`countImg.php`);
  }

  public byId(id: number) {
    return this.http
      .get<Image>(`${ImageService.prefix}/view/${id}.json`).pipe(map(result => result['image']))
      .pipe(map(image => Object.assign(new Image(), image)));
  }

  public hit(id: number) {
    return this.http
      .get<Image>(`${ImageService.prefix}/hit/${id}.json`);
  }

  public byCategory(catId: number) {
    return this.http.get<Image[]>(`${ImageService.prefix}/index/${catId}.json`);
  }

  public byKeyword(keywordId: number) {
    return this.http
      .get<Image[]>(`${KeywordService.prefix}/index/${keywordId}.json`)
      .pipe(map(result => result['keyword'][0]['images']))
  }

  public schlaglicht() {
    return this.http.get<Image>(`${ImageService.prefix}/schlaglicht.json`)
      .pipe(
        map(result => result['image']),
        map(image => Object.assign(new Image(), image)
        )
      )
  }

  public byDate(year: number, month: number, day: number) {
    return this.http.get<any>(`${ImageService.prefix}/date/${year}/${month}/${day}.json`)
      .pipe(
        map(result => result['image']),
        map(image => image ? Object.assign(new Image(), image) : null)
      );
  }

}
